module.exports = __webpack_public_path__ + "static/img/upload-icon.cb80c8c2.png";